<template>
	<ul class="main-menu">

		<template v-for="menux in getMenu()">
			<li class="sub-header">{{ menux.header }}</li>
			<li class="has-sub-menu" v-for="menu in menux.menus"
			    v-on:click="openMenu(menu)"
			    v-on:mouseover="(w >= 1200) ? menu.active = true : ''"
			    v-on:mouseleave="(w >= 1200) ? menu.active = false : ''"
			    :class="(menu.active) ? 'active' : ''">
				<a :href="(menu.sub) ? 'javascript:void()' : '/#/'+menu.route" :class="(!menu.sub) ? 'docka' : ''">
					<div class="icon-w" v-intro-hint="(menu.hint) ? menu.hint : false">
						<i :class="menu.icon"></i>
					</div>
          <span class="capitalize">{{ menu.title }} <span class="badge badge-danger mr-2 pull-right" v-if="menu.hasOwnProperty( 'count' )" :id="menu.count">0</span></span>
				</a>
				<div class="sub-menu-w" v-if="menu.sub" >
					<div class="sub-menu-header">
						{{ menu.title }}
					</div>
					<div class="sub-menu-icon">
						<i :class="menu.icon"></i>
					</div>
					<div class="sub-menu-i">
						<ul class="sub-menu capitalize">
							<li v-for="(index, sub) in menu.sub">
								<a :href="'/#/'+index.route" class="docka">{{ index.title }}</a>
							</li>
						</ul>
					</div>
				</div>
			</li>
		</template>
		<li>
			<div class="mt-4">
				<div class="pull-left">
					{{ t.dark_mode }}
				</div>
				<div id="toggles" class="pull-right">
					<input type="checkbox" id="darkmode__" v-model="darkMode" name="darkmode__" value="1" class="ios-toggle">
					<label for="darkmode__" class="checkbox-label"></label>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>

    export default {
        name: 'dock',
        data () {
            return {
                w: window.innerWidth,
	              darkMode: false,
                t: this.$root.t,
                tinfo: this.$root.tinfo,
                active: false,
                pendingTransactions: (window.hasOwnProperty( 'pendingTransactions' )) ? window.pendingTransactions : {payment: {total: 0}, withdrawal: {total: 0}},
				        session: window.session,
	              userRole: null,
                menus: [
	                {
	                  header: '',
		                menus:
		                    [
                                {route: '', title: 'Dashboard', icon: 'os-icon os-icon-grid-circles', active: false, hint: this.$root.tinfo['OVERVIEW_FINANCIAL'] },
                                {route: '', title: this.$root.t.users, icon: 'icon-user', active: false, hint: this.$root.tinfo['LIST_ALL_USEERS'],
                                    sub: [
                                        { route: 'user?group[]=5', title: this.$root.t.user.groups.ROLE_CLIENT, icon: 'tx' },
                                        { route: 'user?group[]=9', title: this.$root.t.user.groups.ROLE_OPERATOR, icon: 'tx' },
                                        { route: 'user?group[]=8', title: this.$root.t.user.groups.ROLE_PERSONAL, icon: 'tx' },
                                        { route: 'user?group[]=2', title: this.$root.t.user.groups.ROLE_ADMIN, icon: 'tx' },
                                        { route: 'user', title: this.$root.t.show_all, icon: 'tx' },
                                    ]
                                },
                                {route: 'user?group[]=3', title: this.$root.t.resellers, icon: 'icon-people', active: false, hint: this.$root.tinfo['LIST_REESELLERS']},
                                {route: 'user?group[]=5', title: this.$root.t.clients, icon: 'icon-people', active: false, hint: this.$root.tinfo['LIST_ALL_USEERS']},
                                {route: '', title: this.$root.t.navigation.roles_and, icon: 'os-icon os-icon-crown', active: false, hint: this.$root.tinfo['LIST_ROLES'],
                                    sub: [
                                        { route: 'roles/roles', title: this.$root.t.navigation.roles, icon: 'tx' },
                                        { route: 'roles/permissions', title: this.$root.t.navigation.permissions, icon: 'tx' }
                                    ]
                                },
                                {route: '', title: this.$root.t.sessions, route: 'sessions', icon: 'fa fa-clock-o', active: false, hint: this.$root.tinfo['LIST_SESSIONS']},
                                {route: '', title: this.$root.t.navigation.reports, route: 'reports', icon: 'os-icon os-icon-newspaper', active: false, hint: this.$root.tinfo['LIST_REPORT']},
                                {route: '', title: this.$root.t.navigation.analytics, icon: 'os-icon os-icon-bar-chart-stats-up', active: false, hint: this.$root.tinfo['LIST_ANALYTICS'],
                                    sub: [
                                        { route: 'analytics/session', title: this.$root.t.navigation.session_analytics, icon: 'tx' },
                                        { route: '', title: this.$root.t.navigation.action_analytics, icon: 'tx' }
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.accounting, icon: 'os-icon os-icon-phone-21', active: false, hint: this.$root.tinfo['LIST_ACCOUNTS'],
                                    sub: [
                                        { route: 'deposit-accounts', title: this.$root.t.navigation.deposit_accounts, icon: 'tx' },
                                        { route: 'transactions', title: this.$root.t.navigation.transactions, icon: 'tx' },
                                        { route: 'orders', title: this.$root.t.navigation.orders, icon: 'tx' },
                                        { route: 'credits', title: this.$root.t.navigation.credits, icon: 'tx' },
                                        { route: 'receipts', title: this.$root.t.navigation.receipts, icon: 'tx' },
                                        { route: 'configuration/transactions-limitations', title: this.$root.t.navigation.transactions_limitations, icon: 'tx' },
                                        { route: 'payment-methods', title: this.$root.t.navigation.payment_methods, icon: 'icon-credit-card'}

                                    ]
                                },
                                {route: '', title: this.$root.t.promotions, icon: 'icon-star', active: false, hint: this.$root.tinfo['LIST_PROMOTIONS'],
                                    sub: [
                                        { route: 'promotions?mod=2', title: this.$root.t.navigation.casino_bonuses, icon: 'tx' },
                                        { route: 'promotions?mod=1', title: this.$root.t.navigation.sportsbook_bonuses, icon: 'tx' },
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.system_preferences, icon: 'icon-globe', active: false, hint: this.$root.tinfo['SYSTEM_CONF'],
                                    sub: [
                                        { route: 'configuration/system', title: this.$root.t.navigation.system_settings, icon: 'tx' },
                                        { route: 'configuration/domain-names', title: this.$root.t.navigation.domain_names, icon: 'tx' },
                                        { route: 'configuration/company', title: this.$root.t.navigation.company_info, icon: 'tx' },
                                        { route: 'configuration/user-agreement', title: this.$root.t.navigation.user_agreement, icon: 'tx' },
                                        { route: 'configuration/privacy-policy', title: this.$root.t.navigation.privacy_policy, icon: 'tx' },
                                    ]
                                },
		                    ]
	                },
                  {
                      header: this.$root.t.navigation.finance,
                      menus:
                          [
                              {route: 'money-transfer', title: this.$root.t.user.add_balance, icon: 'os-icon os-icon-coins-4', active: false, hint: this.$root.t.user.add_balance },
                              {route: 'orders?type[]=30&type[]=31&status[]=Pending&status[]=PendingApproval', count: 'paymentCount', title: this.$root.t.navigation.deposit_transactions, icon: 'os-icon os-icon-arrow-2-up', active: false, hint: this.$root.tinfo['DEPOSIT_ORDERS'] },
                              {route: 'orders?type[]=5&type[]=9&type[]=10&type[]=16&type[]=32&status[]=Pending&status[]=PendingApproval', count: 'withdrawCount', title: this.$root.t.navigation.withdraw_transactions, icon: 'os-icon os-icon-arrow-2-down', active: false, hint: this.$root.tinfo['WITHDRAWAL_ORDERS'] },
                              {route: 'transactions', title: this.$root.t.navigation.transactions, icon: 'os-icon os-icon-ui-92', hint: this.$root.tinfo['LIST_TRANSACTIONS'] },
                              {route: 'casino-transactions', title: this.$root.t.navigation.casino_history, icon: 'os-icon os-icon-ui-92', hint: this.$root.tinfo['CASINO_TRANSACTIONS'] },
                              {route: 'bonus-calculator', title: this.$root.t.navigation.bonus_calculator, icon: 'os-icon os-icon-wallet-loaded', hint: this.$root.tinfo['LIST_TRANSACTIONS'] },
                          ]
                  },
	                {
                        header: this.$root.t.navigation.sportsbook,
                        menus:
                            [
                                {route: 'fixture/configuration', title: this.$root.t.navigation.configuration, icon: 'icon-settings', active: false, active: false, hint: this.$root.tinfo['SPORTSBOOK_CONF'],
                                    sub: [
                                        {route: 'configuration/bet-slip-stake-limitations', title: this.$root.t.navigation.bet_slip_limits, icon: '', active: false },
                                    ]
                                },
                                {route: 'fixture/configuration', title: this.$root.t.navigation.risk_management, icon: 'icon-settings', active: false, active: false, hint: this.$root.tinfo['SPORTSBOOK_CONF'],
                                    sub: [
                                        {route: 'configuration/bet-slip-stake-limitations', title: this.$root.t.navigation.bet_slip_limits, icon: '', active: false },
                                        {route: 'configuration/market-limitations', title: this.$root.t.navigation.market_limitations, icon: '', active: false },
                                        {route: 'configuration/market-ladder', title: this.$root.t.navigation.market_ladder, icon: '', active: false },
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.sport_bets, icon: 'icon-calculator', active: false, hint: this.$root.tinfo['LIST_SPORTBET'],
                                    sub: [
                                        {route: 'bets', title: this.$root.t.bet_list, icon: '', active: false },
	                                      {route: 'report/bet-match?period=today', title: this.$root.t.navigation.match_trends, icon: '', active: false },
                                        {route: 'report/bet-market?period=today', title: this.$root.t.navigation.bet_trends, icon: '', active: false },
                                        {route: 'report/competition-match?period=today', title: this.$root.t.navigation.competition_trends, icon: '', active: false },
                                        {route: 'report/sport-match?period=today', title: this.$root.t.navigation.sport_trends, icon: '', active: false },
                                        {route: 'report/bet-user-rewards?period=today', title: this.$root.t.navigation.bet_award_history, icon: '', active: false },
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.fixture, icon: 'icon-calendar', active: false, hint: this.$root.tinfo['LIST_FIXTURE'],
                                    sub: [
                                        {route: 'fixture', title: this.$root.t.navigation.matches, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.today, icon: '', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.tomorrow, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.upcoming, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1&allTime=true', title: this.$root.t.sportsbook.filter.all_time, icon: '', active: false },
                                    ]
                                },
                                {route: '', title: this.$root.t.navigation.live_fixture, icon: 'icon-fire', active: false, active: false, hint: this.$root.tinfo['LIVE_FIXTURE'],
                                    sub: [
                                        {route: 'fixture?onLive=1', title: this.$root.t.sportsbook.filter.playing, icon: '', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.today, icon: '', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.tomorrow, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1', title: this.$root.t.sportsbook.filter.upcoming, icon: 'os-icon os-icon-grid-circles', active: false },
                                        {route: 'fixture?isLive=1&allTime=true', title: this.$root.t.sportsbook.filter.all_time, icon: '', active: false },
                                    ]
                                },
                              {route: 'region', title: this.$root.t.navigation.regions, icon: 'icon-location-pin', active: false },
                              {route: 'competition', title: this.$root.t.navigation.competition, icon: 'icon-globe-alt', active: false },
                              {route: 'class', title: this.$root.t.navigation.class, icon: 'os-icon os-icon-award', active: false },
                              {route: 'market', title: this.$root.t.navigation.market, icon: 'icon-book-open', active: false },
                              {route: 'sports', title: this.$root.t.navigation.sport, icon: 'fa fa-eercast', active: false },
                            ]
                  },
                  {
                    header: this.$root.t.navigation.casino,
                    menus: [
                      {route: 'casino/games', title: this.$root.t.navigation.games, icon: 'ti-game', active: false},
                      {route: 'casino/providers', title: this.$root.t.navigation.providers, icon: 'ti-package', active: false},
                    ]
                  },
                  {
                        header: this.$root.t.navigation.feedstation,
                        menus: [
                              {route: '', title: 'Channels', icon: 'os-icon os-icon-hierarchy-structure-2', active: false },
                              {route: '', title: 'Ladder', icon: 'os-icon os-icon-sliders', active: false },
                            ]
                  }
                ],
              reseller: [
                          {
                              header: '',
                              menus:
                                  [
                                      {route: '', title: 'Dashboard', icon: 'os-icon os-icon-grid-circles', active: false },
                                      {route: 'user?group[]=3', title: this.$root.t.resellers, icon: 'icon-people', active: false},
                                      {route: 'user?group[]=5', title: this.$root.t.clients, icon: 'icon-people', active: false},
                                      {route: '', title: this.$root.t.sessions, route: 'sessions', icon: 'fa fa-clock-o', active: false},
                                      {route: '', title: this.$root.t.navigation.reports, route: 'reports', icon: 'os-icon os-icon-newspaper', active: false},
                                      {route: 'deposit-accounts', title: this.$root.t.navigation.deposit_accounts, icon: 'os-icon os-icon-coins-4' },
                                      { route: 'transactions', title: this.$root.t.navigation.transactions, icon: 'os-icon os-icon-tasks-checked' },
                                      {route: 'bets', title: this.$root.t.bet_list, icon: 'os-icon os-icon-newspaper', active: false },
                                  ]
                          },
              ],
              terminal: [
                {
                    header: 'Terminal',
                    menus: [
                        {route: 'terminal/devices', title: 'Devices', icon: 'os-icon os-icon-monitor', active: false },
                        {route: 'terminal/create', title: 'Setup a device', icon: 'os-icon os-icon-delivery-box-2', active: false },
                    ]
                }
              ]
            }
        },
          watch: {
                'darkMode' (o,n) {
                    this.$bus.$emit('darkMode', this.darkMode)
                },

          },
          mounted () {
          var self = this;
                this.$getItem('darkMode', function (key, value) {
                    //console.log all the kay/value pairs
                    self.darkMode = value;
                    self.$root.darkMode = value;

                }, function (err) {

                })
        },
        methods: {
            openMenu (menu) {
                if (menu.active == false) {
                    menu.active = true;
                } else {
                    menu.active = false;
                }
            },
            getMenu (){
                return (this.session.group.key == 'ROLE_RESELLER') ? this.reseller : ((this.session.group.key == 'ROLE_TERMINAL') ? this.terminal : this.menus);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/dock.vue